import { Divider } from '@mui/material'

import { form } from '../../formState'

import { useTexts } from '../useTexts'

import { ServiceTime } from './ServiceTime'
import { TimeWindows } from './TimeWindows'

export function ServiceTimeAndAvailabilities() {
  const texts = useTexts()
  return (
    <form.Fieldset>
      <form.SectionTitle variant="alternative">
        {texts.getServiceTimeAndAvailabilitiesTitle}
      </form.SectionTitle>
      <ServiceTime />
      <TimeWindows />
      <Divider />
    </form.Fieldset>
  )
}
